import apiEnvironment from './api';
import docusealEnvironment from './docuseal';
import featureFlagEnvironment from './feature-flag';
import firebaseEnvironment from './firebase';
import nodeEnvironment from './node';

const environment = {
  api: apiEnvironment,
  docuseal: docusealEnvironment,
  firebase: firebaseEnvironment,
  featureFlag: featureFlagEnvironment,
  nodeEnvironment: nodeEnvironment,
};

export default environment;
